import configurl from '@/config/user.env';
import { resTemplateDownloadApi, importCustomerPersonResponsibleImport, RespDetailDeltemplateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
export const uploadConfig = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: resTemplateDownloadApi,
    importApi: importCustomerPersonResponsibleImport,
    downParams: {
        fileName: '导入模板.xlsx',
        fileId: 'respAchievementImport.xlsx'
    },
    multiple: false,
    accept: 'xlsx',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};

// 下载导入删除模板
export const uploadDeleteConfig = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: RespDetailDeltemplateDownloadApi,
    importApi: importCustomerPersonResponsibleImport,
    downParams: {
        fileName: '责任制数据导入删除模板.xlsx',
        fileId: 'respAchievementImport.xlsx'
    },
    multiple: false,
    accept: 'xlsx',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
